import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const LeaveGroupIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    d='M15 13.1C14.6712 13.0311 14.3359 12.9976 14 13H8C6.67392 13 5.40215 13.5268 4.46447 14.4645C3.52678 15.4021 3 16.6739 3 18V19C3 19 5 21 11 21C12.0032 21.0051 13.0055 20.9417 14 20.81C14.35 20.81 14.69 20.71 15 20.64M17 17H21M16 8C16 8.98891 15.7068 9.95561 15.1573 10.7779C14.6079 11.6001 13.827 12.241 12.9134 12.6194C11.9998 12.9978 10.9945 13.0969 10.0245 12.9039C9.05464 12.711 8.16373 12.2348 7.46447 11.5355C6.7652 10.8363 6.289 9.94536 6.09607 8.97545C5.90315 8.00555 6.00216 7.00021 6.3806 6.08658C6.75904 5.17295 7.3999 4.39206 8.22215 3.84265C9.04439 3.29324 10.0111 3 11 3C12.3261 3 13.5979 3.52678 14.5355 4.46447C15.4732 5.40215 16 6.67392 16 8Z'
    stroke='#ED364C'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round' />
</Svg>;

export default LeaveGroupIcon;
